var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38462 18C8.4 18 9.23077 17.1692 9.23077 16.1538H5.53846C5.53846 17.1692 6.36923 18 7.38462 18ZM12.9231 12.4615V7.84615C12.9231 5.01231 11.4185 2.64 8.76923 2.01231V1.38462C8.76923 0.618462 8.15077 0 7.38462 0C6.61846 0 6 0.618462 6 1.38462V2.01231C3.36 2.64 1.84615 5.00308 1.84615 7.84615V12.4615L0 14.3077V15.2308H14.7692V14.3077L12.9231 12.4615ZM11.0769 13.3846H3.69231V7.84615C3.69231 5.55692 5.08615 3.69231 7.38462 3.69231C9.68308 3.69231 11.0769 5.55692 11.0769 7.84615V13.3846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlack);
export default __webpack_public_path__ + "static/media/bell_black.ecc5d3a6da0e7e8190ed3e9f173bb8c8.svg";
export { ForwardRef as ReactComponent };